<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group label="انتخاب نقش کاربر" label-for="user-type-picker">
          <v-select
            :clearable="false"
            :disabled="isDisabled"
            id="user-type-picker"
            dir="rtl"
            :filterable="false"
            v-if="rolesList"
            :reduce="(userType) => userType.userTypeId"
            v-model="selectedUserTypeId"
            :options="rolesList"
            label="title"
            placeholder="نقش کاربر را انتخاب کنید"
          >
            <template #no-options>هیچ نقشی جهت نمایش وجود ندارد</template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getUserTypeId"],
  props: {
    defaultUserTypeId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    selectedUserTypeId: {
      handler(val) {
        this.$emit("getUserTypeId", val);
      },
    },
    defaultUserTypeId: {
      handler(val) {
        if (val && val != "" && val != 0) {
          this.getAllRoles();
        }
      },
    },
  },
  mounted() {
    this.getAllRoles();
  },
  data() {
    return {
      rolesList: null,
      selectedUserTypeId: null,
    };
  },
  methods: {
    async getAllRoles() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUserTypes = new GetAllUserTypes(_this);
        await getAllUserTypes.fetch(
          function (response) {
            _this.rolesList = response;
            if (_this.defaultUserTypeId) {
              _this.selectedUserTypeId = _this.defaultUserTypeId;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllUserTypes } from "@/libs/Api/UserType";
</script>
